import { combineReducers } from 'redux';
import list from './list.reducers';

const dispenseTrackerReducers = combineReducers({
  list,
});

export default dispenseTrackerReducers;
